import React from 'react';
import { useShowContext } from 'ui-builder';
import { EventTask, TaskType } from 'nekst-api';
import Layout from './Layout';

export function EventField() {
  const context = useShowContext<EventTask>();

  if (context?.data.type === TaskType.EVENT) {
    const isDeactivated = context.data.isDeactivated ?? false;
    const title = isDeactivated ? 'Event was removed' : 'Event task';

    return (
      <Layout title={title} isDeactivated={isDeactivated} />
    );
  } else {
    return null;
  }
}
